import { MediaCarousel } from '@euler/app/components/media/MediaCarousel';
import { Typography } from '@euler/app/components/typography';
import { OrderExtra } from '@euler/app/flows/order/types';
import { VehicleFacadeBirdView } from '@euler/app/flows/report/components/VehicleFacadeBirdView';
import { useContainerLayout } from '@euler/components/layout/LayoutProvider';
import { HStack } from '@euler/components/layout/Stack';
import { getDefectiveLevelColor } from '@euler/functions/getDefectiveLevel';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FacadeSiteConfig } from '@euler/model';
import { memo, useMemo } from 'react';
import { View } from 'react-native';
import { useTheme } from 'styled-components';
import {
  FacadeInfoResultGroup,
  usePreviewOrderFacadeInfo,
} from '../functions/usePreviewOrderFacadeInfo';
import { OrderPreviewSection as Section } from './Section';

export const FacadeInfoSection = memo(({ detail }: { detail: OrderExtra }) => {
  const { overlays, normalSites, groupsWithIssues, recordGroups } =
    usePreviewOrderFacadeInfo(detail);
  const { width } = useContainerLayout();
  const { rpx } = useResponsiveContext();
  const groups = useMemo(
    () => [...groupsWithIssues, ...recordGroups],
    [groupsWithIssues, recordGroups],
  );
  return (
    <Section title="车辆外观状态">
      <VehicleFacadeBirdView overlays={overlays} size={width - rpx(15) * 2} />
      <Results groups={groups} normalSites={normalSites} />
    </Section>
  );
});

const Results = memo(
  ({
    groups,
    normalSites,
  }: {
    groups: FacadeInfoResultGroup[];
    normalSites: FacadeSiteConfig[];
  }) => {
    const theme = useTheme();
    const { width } = useContainerLayout();
    const { rpx } = useResponsiveContext();
    const mediaHeight = (width - rpx(15) * 2) * 0.75;

    return (
      <>
        {groups.map(group => (
          <View
            key={group.name}
            css={`
              padding: ${rpx(10)}px ${rpx(15)}px;
            `}
          >
            <HStack
              css={`
                margin-bottom: ${rpx(10)}px;
              `}
            >
              <Typography.Label bold color="rgb(102, 102, 102)" size={rpx(16)}>
                {group.name}
              </Typography.Label>
              <Typography.Label
                color={getDefectiveLevelColor(theme, group.defectiveLevel)}
              >
                {group.result}
              </Typography.Label>
            </HStack>
            <MediaCarousel
              medias={group.medias}
              css={`
                height: ${mediaHeight}px;
                border-radius: ${rpx(10)}px;
                overflow: hidden;
              `}
            />
          </View>
        ))}
        {normalSites.map(site => (
          <View
            key={site.code}
            css={`
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            `}
          >
            <Typography.Label bold size={rpx(14)}>
              {site.name}外观
            </Typography.Label>
            <Typography.Label
              regular
              size={rpx(14)}
              color={theme.colors.defectiveLevel.normal}
            >
              良好
            </Typography.Label>
          </View>
        ))}
      </>
    );
  },
);
